<template>
  <div>
    <el-col :span="24" v-loading="loading" element-loading-text="拼命加载中" style="height: 355px">
      <!--列表-->
      <el-table :data="typeList" height="356" ref="multipleTable" @selection-change="selectionChange"
                :row-key="getRowKeys">
        <el-table-column type="selection" :reserve-selection="true" min-width="7"></el-table-column>
        <el-table-column prop="text" label="类型名称" min-width="50"></el-table-column>
      </el-table>
    </el-col>

  </div>
</template>
<script>
import API from '@/api/api_role';
import DIC_API from '@/api/api_dictionary';

export default {
  data() {
    return {
      filters: {
        typeName: ''
      },
      typeList: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,

      isSelectionIn: false,

      enterpriseId: undefined
    }
  },

  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    search() {
      let that = this;
      // let params = Object.assign({
      //   page: that.page,
      //   limit: 10,
      //   enterpriseId: this.enterpriseId
      // }, that.filters);
      that.loading = true;
      //人员类型
      DIC_API.getListByParentCode({
        parentCode: 'person_type'
      }).then((result) => {
        // console.log(result)
        if (result && result.length > 0) {
          that.typeList = result;
          that.loading=false;
        }
      }, function (err) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: err.toString(),
          duration: 2000
        });
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    selectionChange(e) {
      this.selectDataList = [];
      // console.log(e)
      if (e) {
        e.forEach(obj => {
          let typeName = obj.text;
          if (!typeName.startsWith('「类型」')) {
            typeName = '「类型」' + typeName;
          }
          this.selectDataList.push({
            key: obj.code,
            label: typeName,
            personType: "4"
          })
        })
      }
      if (!this.isSelectionIn) {
        // console.log( this.selectDataList)
        this.$emit("selection-change", this.selectDataList);
      }
    },
    getRowKeys(row) {
      return row.code;
    },
    setSelection(rows) {
      // console.log(rows)
      this.isSelectionIn = true;
      if (this.selectDataList) {
        this.$refs.multipleTable.clearSelection();
      }
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection({
            key: row.key,
            code: row.key,
            label: row.label,
            text: row.label
          });
        });
        this.tableReload();
      }
      this.isSelectionIn = false;
    },
    tableReload() {
      this.typeList = JSON.parse(JSON.stringify(this.typeList));
    }
  },
  mounted() {
    this.handleSearch();
    let userInfo = JSON.parse(localStorage.getItem('userinfo'));
    this.enterpriseId = userInfo.enterpriseId;
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/trainingManagement/component/user/typeSelection.vue